import { useEffect, useState, useMemo, useRef } from "react";
import { getAll, Amount } from "../actions/studensts";
import { useDispatch, useSelector } from "react-redux";
import Table from "./Table/Table";
import Pagination from "./Table/Pagination";
import Search from "./Table/Search";
import { Link } from "react-router-dom";
import { exportToExcel } from "./exportToExcel";
import { REPORT_USERS } from "./Reports/Reports";
import ColumnNavigator from "../components/ColumnNavigator";
import { heads } from "./Table/Table/config";

function Main() {
  const { students, count } = useSelector((state) => state.students);
  // Create a fast index for students by national ID (or any unique field)
  const studentIndex = useMemo(() => {
    if (!students) return {};
    const index = {};
    for (const student of students) {
      if (student.id) index[student.id] = student;
    }
    return index;
  }, [students]);
  const [selected, setSelected] = useState(false);
  const [page, setPage] = useState(1);
  const [nextDisabled, setNextDisabled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loading1, setLoading1] = useState(false);
  const [search, setSearch] = useState("");
  const [hasSearched, setHasSearched] = useState(false);
  const [dailyAmount, setDailyAmount] = useState(0);
  const [allAmount, setAllAmount] = useState(0);
  const [selectState, setSelectState] = useState("all");
  const tableRef = useRef(null);
  const dispatch = useDispatch();
  const user = JSON.parse(localStorage.getItem("profile")).value[0];
  const canSeeReports = REPORT_USERS.includes(user.username);

  const handleNavigateToColumn = (columnIndex) => {
    if (tableRef.current) {
      tableRef.current.scrollToColumn(columnIndex);
    }
  };

  const getSelectState = (state) => {
    let newSelected = selectState;
    newSelected = state;
    setSelectState(newSelected);
  };


const getDailyAmount = async () => {
  if (user.role === 'admin') {
    setLoading1(true);
    try {
      const res = await Amount();
      if (res && res.data) {
        setDailyAmount(res.data.daily_amount);
        setAllAmount(res.data.total_amount);
      }
    } catch (error) {
      console.error('Error fetching daily amount:', error);
    } finally {
      setLoading1(false);
    }
  }
};


  // clear students on mount
  useEffect(() => {
    dispatch({ type: "CLEAR" });
    setHasSearched(false);
  }, [dispatch]);

  // update students on search term changes (immediate, no debounce since button controls it)
  useEffect(() => {
    if (!hasSearched) return;
    if (search && search.length < 3) return;
    
    // Clear students on new search to prevent flickering
    dispatch({ type: "CLEAR" });
    setLoading(true);
    dispatch(getAll(page, search)).finally(() => setLoading(false));
  }, [search, dispatch, hasSearched]);

  // update students on page changes (immediate, don't clear for smooth pagination)
  useEffect(() => {
    if (!hasSearched) return;
    if (search && search.length < 3) return;
    
    setLoading(true);
    dispatch(getAll(page, search)).finally(() => setLoading(false));
  }, [page]);

  // disabled the next button if in last page
  useEffect(() => {
    getDailyAmount();
    if (page === count?.maxPage) {
      setNextDisabled(true);
    } else {
      setNextDisabled(false);
    }
  }, [count?.maxPage, page]);

  return (
    <div>
      <div className="flex flex-wrap justify-between p-5">
        <h1 className="text-2xl p-3 text-white">Main Page</h1>
        <div className="flex flex-wrap justify-between">
          {user.role === "invoice" || user.username === "admin" ? (
            <div className="p-3">
              <h2 className="text-xl bg-green-700 p-3 rounded  text-white">
                Daily Amount:{" "}
                <span className="text-xl px-2 rounded bg-white text-red-800">
                  {loading1 ? "Loading..." : dailyAmount}
                </span>
              </h2>
            </div>
          ) : (
            ""
          )}
          {user.role === "invoice" || user.username === "admin" ? (
            <div className="p-3">
              <h2 className="text-xl bg-green-700 p-3 rounded  text-white">
                Total Amount:{" "}
                <span className="text-xl px-2 rounded bg-white text-red-800">
                  {loading1 ? "Loading..." : allAmount}
                </span>
              </h2>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
      <div>
        <div className="w-full max-w-3xl mx-auto px-3">
          {(user.username === "asmaa" ||
            user.username === "abdelrhman" ||
            user.username === "alaa" ||
            user.username === "officer" ||
            user.username === "acountant-1") && (
            <div className="p-3 w-72 flex justify-between mx-auto">
              <div>
                <div>
                  <label className="fs-4 fw-normal text-white" htmlFor="states">
                    Select a State to Export:{" "}
                  </label>
                </div>
                <select
                  onChange={(e) => getSelectState(e.target.value)}
                  className="w-40 p-1"
                  id="states"
                >
                  <option value="all">all</option>
                  <option value="auditing">auditing</option>
                  <option value='auditing_pending'>Auditing_pending</option>
                  <option value="invoice">invoice</option>
                  <option value="invoice_wait">invoice_wait</option>
                  <option value="another_invoice">another_invoice</option>
                  <option value="request_edit">request_edit</option>
                  <option value="score_validation">score_validation</option>
                  <option value="score_request">score_request</option>
                  <option value="score_pending">score_pending</option>
                  <option value="print">print</option>
                  <option value="print_validation">print_validation</option>
                  <option value="moe_validation">moe_validation</option>
                  <option value="moe">moe</option>
                  <option value="moe_pending">moe_pending</option>
                  <option value="deliver_onsite">deliver_onsite</option>
                  <option value="aramex">aramex</option>
                  <option value="mohe_validation">mohe_validation</option>
                  <option value="mohe">mohe</option>
                  <option value="done">done</option>
                </select>
              </div>
              <button
                type="button"
                className="text-white bg-green-900 hover:bg-green-800 p-2
                        focus:ring-4 focus:ring-green-400 font-medium rounded-lg text-sm text-center cursor-pointer"
                onClick={() => exportToExcel(selectState)}
              >
                Export
              </button>
            </div>
          )}

          {canSeeReports && (
            <div className="flex justify-center p-3">
              <Link
                to="/main/reports"
                className="text-white bg-indigo-700 hover:bg-indigo-600 px-5 py-2
                        focus:ring-4 focus:ring-indigo-400 font-medium rounded-lg text-sm"
              >
                Open Reports Page
              </Link>
            </div>
          )}

          <div className="max-w-md mx-auto">
            <Search
              setSearch={(val) => {
                if (val === "") {
                  // Clear everything when search is empty
                  dispatch({ type: "CLEAR" });
                  setHasSearched(false);
                } else {
                  setHasSearched(true);
                }
                setSearch(val);
              }}
              setPage={setPage}
            />
          </div>
        </div>
        <div className="overflow-auto p-3">
          {!hasSearched ? (
            <div className="text-center text-white p-20 text-2xl">
              Enter Search Term to Load Data...
            </div>
          ) : loading ? (
            <div className="text-center p-20">
              <div className="flex flex-col items-center gap-4">
                <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-orange-500"></div>
                <p className="text-white text-xl">Loading data, please wait...</p>
              </div>
            </div>
          ) : students && students.length > 0 ? (
            <>
              <div className="mb-3">
                <ColumnNavigator columns={heads} onNavigate={handleNavigateToColumn} />
              </div>
              <Table
                ref={tableRef}
                selected={selected}
                setSelected={setSelected}
                students={students}
                studentIndex={studentIndex} // Pass the index for fast lookup
              />
            </>
          ) : (
            <div className="text-center text-white p-20 text-2xl">
              No results found
            </div>
          )}
        </div>
        <div className="py-4">
          <Pagination
            page={page}
            setPage={setPage}
            maxPage={count?.maxPage}
            nextDisabled={nextDisabled}
          />
        </div>
      </div>

    </div>
  );
}

export default Main;